import axios from 'axios';
import { API } from '@config/common';

export const deleteSchedule = (scheduleId) => {
  return axios({
    method: 'delete',
    url: API.SCHEDULE + scheduleId,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const createSchedule = (
  scheduleName,
  startDatetime,
  endDatetime,
  userId,
  users,
) => {
  return axios({
    method: 'post',
    url: API.SCHEDULE,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({
      users,
      name: scheduleName,
      start_datetime: startDatetime,
      end_datetime: endDatetime,
      user_id: userId,
    }),
  });
};

export const updateSchedule = (
  scheduleId,
  scheduleName,
  startDatetime,
  endDatetime,
) => {
  return axios({
    method: 'put',
    url: API.SCHEDULE + scheduleId,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    params: { id: scheduleId },
    data: JSON.stringify({
      name: scheduleName,
      start_datetime: startDatetime,
      end_datetime: endDatetime,
    }),
  });
};

export const scheduleSelect = (payload) => {
  return axios({
    method: 'get',
    url: API.SCHEDULE,
    headers: { authorization: sessionStorage.getItem('accessToken') },
    params: {
      start_datetime: payload.start_datetime,
      end_datetime: payload.end_datetime,
    },
  });
};

export const scheduleSave = (schedules) => {
  return axios({
    method: 'put',
    url: API.SCHEDULE,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    data: JSON.stringify({ schedules }),
  });
};
